import { Button } from '@mui/material';
import React from 'react';

const backdropStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000
};

const popupStyle = {
  backgroundColor: '#fff',
  padding: '24px',
  borderRadius: '8px',
  maxWidth: '400px',
  width: '100%',
  boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
};

const headerStyle = {
  marginBottom: '12px',
  fontSize: '18px',
  fontWeight: 600
};

const textStyle = {
  fontSize: '14px',
  lineHeight: 1.5
};

const Popup = ({ open, title, text, onClose }) => {
  if (!open) return null;

  return (
    <div style={backdropStyle} onClick={onClose}>
      <div style={popupStyle} onClick={(e) => e.stopPropagation()}>
        <div style={headerStyle} font-size='24px'>{title}</div>
        <div style={textStyle} font-size='18px'>{text}</div>
        <div style={{ marginTop: '20px', textAlign: 'right', alignContent: 'flex-end' }}>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
        >
          Close
        </Button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
